/* KORA · StayFem — comportamiento compartido del rediseño */
(function () {
  // Fecha de entrega estimada en días laborables (la página puede estar cacheada)
  function addBusinessDays(date, days) {
    var d = new Date(date);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }
  function fmt(d) {
    return d.toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' });
  }
  function initDelivery(root) {
    (root || document).querySelectorAll('[data-sf-delivery]').forEach(function (el) {
      var min = parseInt(el.dataset.min, 10) || 2;
      var max = parseInt(el.dataset.max, 10) || 4;
      var now = new Date();
      var target = el.querySelector('[data-sf-delivery-range]');
      if (target) target.textContent = fmt(addBusinessDays(now, min)) + ' y el ' + fmt(addBusinessDays(now, max));
    });
  }

  // Pestañas accesibles
  function initTabs(root) {
    (root || document).querySelectorAll('[data-sf-tabs]').forEach(function (wrap) {
      if (wrap.dataset.sfReady) return;
      wrap.dataset.sfReady = '1';
      var tabs = wrap.querySelectorAll('[role="tab"]');
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i); });
        tab.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var next = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            select(next);
            tabs[next].focus();
          }
        });
      });
      function select(idx) {
        tabs.forEach(function (t, j) {
          var on = j === idx;
          t.setAttribute('aria-selected', on);
          t.tabIndex = on ? 0 : -1;
          var panel = wrap.querySelector('#' + t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
    });
  }

  // Carruseles con flechas (scroll-snap nativo)
  function initSliders(root) {
    (root || document).querySelectorAll('[data-sf-slider]').forEach(function (wrap) {
      if (wrap.dataset.sfReady) return;
      wrap.dataset.sfReady = '1';
      var track = wrap.querySelector('[data-sf-track]');
      if (!track) return;
      wrap.querySelectorAll('[data-sf-prev],[data-sf-next]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.hasAttribute('data-sf-next') ? 1 : -1;
          track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
        });
      });
    });
  }


  // "Comprar ahora": tras añadir al carrito (tema o Kaching Bundles), ir directo al pago
  (function () {
    var armedAt = 0;
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var btn = e.target.closest('.product-form__submit, [data-sf-sticky-buy]');
      if (!btn) return;
      var scope = btn.closest('product-form, product-info, .product') || document;
      if (btn.hasAttribute('data-sf-sticky-buy') || scope.querySelector('[data-sf-go-checkout]')) armedAt = Date.now();
    }, true);
    function armed() { return armedAt && Date.now() - armedAt < 15000; }
    function go() { armedAt = 0; setTimeout(function () { window.location.href = '/checkout'; }, 120); }
    if (window.fetch && !window.fetch.__sfWrapped) {
      var orig = window.fetch;
      var wrapped = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = orig.apply(this, arguments);
        if (armed() && /\/cart\/add/.test(url)) {
          p.then(function (r) { if (r && r.ok) go(); }).catch(function () {});
        }
        return p;
      };
      wrapped.__sfWrapped = true;
      window.fetch = wrapped;
    }
    var xo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      if (armed() && /\/cart\/add/.test(String(url))) {
        this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) go(); });
      }
      return xo.apply(this, arguments);
    };
  })();

  function init(root) { initDelivery(root); initTabs(root); initSliders(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
